<template>

  <span>
    <b-container fluid>
      <b-row  id="header-container-short" class="justify-content-center">
        <b-col md="10">
          <b-row align-h="between">
            <b-col md="6">
              <a href="/">
                <img alt="gravity logo" src="../../assets/logo-mom-450.png" />
              </a>
            </b-col>
            <b-col md="6" class="started-button">
              <a
                href="/masters-of-marketing"
              >
                <b-button class="button-white-transparen"><b>Explore All Speakers</b></b-button>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>




    <b-container id="body-container" fluid>
      <b-row class="justify-content-center">
        <b-row align-h="start" align-v="center" class="header-text-container" style="text-align: center">
          <b-col cols="12" md="12">
            <span>
              <iframe class="youtubePreview" src="https://www.youtube.com/embed/EdfCBKjx7uU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </span>
          </b-col>
        </b-row>

        <b-col cols="8" md="8" sm="12">

        <b-row class="justify-content-center">
          <b-col md="12" cols="12" class="buttons-center" >
            <a
              href="https://www.facebook.com/groups/themastersofmarketing/" target="_blank"
            >
              <b-button class="join-community"><b>Join the community</b></b-button>
            </a>

            <span v-if="liveStream.presentationAV != ''" style="padding-left: 10px">
            <a
              :href="liveStream.presentationAV" target="_blank"
            >
              <b-button class="join-community"><b>Watch on AlphaVoice</b></b-button>
            </a>
            </span>
          </b-col>
        </b-row>


        <b-row align-center justify-center id="job-offers">
            <b-col md="12" cols="12" >
              <h1>Marketing with Bootstrapped Methodologies in Quarantine</h1>
              <p><b>Main takeaway:</b> <i>Your company WILL suffer by “going dark” and waiting for things to go back to normal. Hit the ground running and don’t slow down.</i></p>
              <p>Taylor Ryan is the CEO of KlintMarketing & ArchitectureQuote and has 12 years of marketing/startup experience. ArchitectureQuote is a project/lead aggregator for the AEC, architecture, and engineering industry. His success in digital marketing is due to his strong understanding of the overlapping connections between systems (i.e. Content, PR, SEO, SEM, Social Media, Email Marketing, Onboarding…) When looking at the recession of 2008, we saw losses and wins that can be helpful when making business decisions in quarantine.</p>
              <p>Some of today's most successful companies (i.e. Disney, Airbnb, IBM, Lego, Adobe…) began during a recession! How did they do it? They didn’t sit on the sidelines waiting for an opportunity or idea to drop on their lap. We’re about to see massive layoffs and startups plunging into darkness so if your market is doing well, now's your time to increase scale and enhance efficiency. For example, let’s look at Hotels. Some hotels shut down their worst performing locations to free up capital. They improved their marketing/branding, upgraded their beds, facilities, and decor, and optimized their websites (Data Integration + UX). And, it worked.</p>
              <p>Since everyone is in freakout mode, you may feel the pressure to create better services/products. Instead, channel that energy to re-engage your relationships with existing clients and create customer loyalty. Look at airline and car transportation sites, they focus on customer service and improving the user experience. Ryan shows us a marketing funnel and how we often miss the last step: delight. Making sure your customers remember you and feel special. You can increase customer retention by sending thank you cards, implementing loyalty programs, giving gifts on anniversaries, sending treats/candy, gifting tickets to events, providing discounts, etc…</p>
              <p></p>
              <p>We see companies that freaked out and cut their ad spending took YEARS to recover. The pandemic sounds worse on social media than it actually is because “Tension is what gets clicks”. It’s important to note that the engagement you see on social media isn’t “real” -- but paid. Just look at the Chinese click farms! Consider that when posting heavily and waiting for traction. Social Media usage is up and everyone is trying to get more websites clicks.</p>
              <p><i>Written By: Jody Kung on May 22, 2020</i></p>
              <p><i>Based on a presentation by: Taylor Ryan</i></p>
            </b-col>
          </b-row>

        </b-col>

        <b-col cols="8">
          <!---------------------------------------------------->

          <b-row>
            <b-col
              md="6"
              class="mt-md-4"
            >
              <writeupBio :guest="liveStream" />
            </b-col>
          </b-row>


          <!----------------------------------------------------->


            <!--
              <b-container class="live-now" fluid>
                <b-row class="flex-column-reverse flex-md-row">
                  <b-col md="8">
                    <b-row>
                      <b-col>
                        <p class="text-white title">{{ liveStream.title }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <p class="text-white sub-title">{{ liveStream.subtitle }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <span>
                          <p class="text-white sub-title">{{ liveStream.datePretty }}, 2020</p>
                        </span>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="4" class="author">
                    <b-row align-h="end" class="mb-2 author2">
                      <a :href="liveStream.linkedinURL" target="_blank">
                        <b-col class="avatar">
                          <b-avatar
                            class="avatar-image"
                            :src="require('../../assets/guests/' + liveStream.photoFileName)"
                          ></b-avatar>
                        </b-col>
                      </a>
                    </b-row>
                    <b-row>
                      <b-col>
                        <p class="text-white name">{{ liveStream.name }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <p class="text-white position-company">{{ liveStream.position }}</p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
            -->

            <!---------------------------------------------------->

         <div class="decorator2">
            <img alt="gravity logo" src="../../assets/decorator2.png" />
          </div>

          <b-row align-center justify-center id="job-offers">
            <b-col md="12" cols="12" >

            </b-col>
          </b-row>

          <div class="decorator1">
            <img alt="gravity logo" src="../../assets/decorator1.png" />
          </div>


        </b-col>
      </b-row>


      <b-row id="launch-today-container" class="justify-content-center live-now">
        <b-col md="10">
          <b-row align-h="start" align-v="center" class="header-text-container">
            <b-col cols="12" md="12">
              <span>
                <h4 class="text-blackish title-body" style="text-align:center; color:white">A community of visionary marketers like you.</h4>
              </span>
              <span>
                <b-row align-v="center" align-h="center">
                  <h6 class="text-blackish" style="text-align:center; color:white; opacity: 0.5;">a community by</h6>
                  <a href="/">
                    <img alt="gravity logo" src="../../assets/logo-150.png" />
                  </a>
                </b-row>
              </span>
            </b-col>
          </b-row>

          <b-row class="">
          <b-col md="12" cols="12" class="buttons-center" >
            <a
              href="https://www.facebook.com/groups/themastersofmarketing/"
              class="d-flex justify-content-center"
            >
              <b-button class="free-trial-button">Join the community</b-button>
            </a>

            <!--
            <a
              href="https://www.launchgravity.com/masters-of-marketing/#upcoming"
            >
              <b-button class="button-white-transparen"><b>Check our events</b></b-button>
            </a>
            -->
          </b-col>
        </b-row>
        </b-col>
      </b-row>

    </b-container>
    <Footer />
  </span>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/screens/home/header.sass
@import @/sass/_components/main-card.sass
</style>

<script>
// components
//import ourTeam from '@/components/ourTeam'

// data
import { guests, yourHosts } from '@/data/masters-of-marketing.js'
import Footer from '@/components/footer.vue'
import writeupBio from '@/components/writeupBio'

export default {
  name: 'Body',
  components: {
    Footer,
    writeupBio
  },
  data: function() {
    return {
      liveStream:{
        name: "Hello",
        title: "How to tie your shoes",
        subtitle: "Loopty loop and pull",
        livenow: 0,
        linkedinURL: "linkedin.com/in/rossegates",
        position:"Co-Founder Gravity",
        headshot: 'ross.jpeg',
      },
      //liveStream: {},
      featureSpeaker: [],
      pastSpeakers: [],
      futureSpeakers: [],
      guests,
      yourHosts,
      timeToShow: 10,
      timer: null,
      currentDate: null,
      dayOfWeek: null,
      month: 1,
      day: 1,
      year: 2020,
      speakerSelection: 1,
      liveRightNow: 0,
      index: 17,



    }
  },
  computed: {
    timeLeft() {
      return `${this.minutes} m ${this.seconds} seconds`
    },
    minutes() {
      return String(Math.floor(this.time / 60)).padStart(2, '0')
    },
    seconds() {
      return String(this.time % 60).padStart(2, '0')
    },
  },
  created() {
    this.orderSpeakers()
    this.setSpeakerRoles()
    //this.timeToShow = this.getTimeToShow(),
    //this.timer = setInterval(this.decrement, 1000)
  },
  methods: {
    orderSpeakers() {
      var currentDate = new Date()

      this.guests.forEach((guestItem, index) => {
        var speakingDate = guestItem.speakingDate
        var year = parseInt(speakingDate.substr(0, 4))
        var month = parseInt(speakingDate.substr(5, 6)) - 1
        var day = parseInt(speakingDate.substr(8, 9))
        var speakerDate = new Date(year, month, day, 0, 0, 0)
        var timeLeft = (speakerDate - currentDate) / 86400000
        var daysLeft = Math.ceil(timeLeft)

        // Store the dates back into the array
        guestItem.daysLeft = timeLeft
        var datePretty = speakerDate.toString().substr(0, 10)
        var ending = [
          '',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
        ]
        if (ending[day] !== undefined) {
          datePretty += ending[day]
        } else {
          datePretty += 'th'
        }
        guestItem.datePretty = datePretty
        if (timeLeft < 1 && timeLeft > -0.082) {
          //this.featuredSpeaker = index
          guestItem.speakerStatus = 1 // featured
        } else if (timeLeft < 3 && datePretty.substr(0, 3) === 'Mon') {
          guestItem.speakerStatus = 1 // featured
        } else if (timeLeft < -0.041) {
          guestItem.speakerStatus = 0 // past
        } else {
          guestItem.speakerStatus = 2 // future
        }

        if (timeLeft < -0.041 && timeLeft > -0.082) {
          this.liveRightNow = 1
        }

        console.log(timeLeft)
        console.log(datePretty)
        console.log(daysLeft)
        console.log(index)
      })
    },
    setSpeakerSelection(page) {
      this.speakerSelection = page
    },
    setSpeakerRoles() {
      for (var i = 0; i < this.guests.length; i++) {
        this.liveStream = this.guests[this.index]
      }
    },

    getTimeToShow() {
      // Get the day of the week = 2
      this.dayOfWeek
      // Get the current time = in date object
      this.currentDate
      // Make sure the timezone is correct

      // Timezone varies depending on Daylight Savings

      // Compare with current time in timezone SF
      // var pacificTime = new Date("2020-04-13T00:00:00.000+08:00")

      // Get Time Until 10:30 AM PST
      // If time before 10:30am PST
      // If time 10:30 - 11           M-F (Skip) Show LIVE NOW
      // If time after 11 am PST      Subtract Hours from 24

      // If Monday,Tuesday,Wed,Thurs

      // If Friday Afternoon

      // If Saturday    Add + 2 days

      // If Sunday morning      Add + 1 day (Afternoon subtract from 24)

      // If
      // If between 10:30 - 11:00 Monday - Friday (Skip) Show LIVE NOW
      //
    },
    decrement() {
      this.time = this.time - 1
    },
  },
}
</script>
